import React, { ReactElement } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { Country } from '@afterpaytouch/portal-api/types'
import { TermLink, TermLinkProps } from '../TermLink'
import { useAmplitudeWithEnduringEventProperties } from '../../integrations/amplitude'
import { TrackingEvent } from '../../model/amplitude'
import { LaunchDarklyFlags, useFlag } from '../../hooks'
import { getCountryCodeFromLocale } from '../../utils/consumer'

interface UseSignUpTermsResult {
  readonly [tagName: string]: ReactElement<TermLinkProps>
}

export const useTermsKey = (): string => {
  const { locale } = useRouter()
  const country = getCountryCodeFromLocale(locale)
  const isAuPayIn4UpdatedTerms = useFlag(LaunchDarklyFlags.AuPayIn4UpdatedTerms)
  if (country === Country.AU && isAuPayIn4UpdatedTerms) {
    return 'signUp:terms_auPayIn4'
  }
  return 'signUp:terms'
}

export const useSignUpTerms = (): UseSignUpTermsResult => {
  const { t } = useTranslation()
  const { logEvent } = useAmplitudeWithEnduringEventProperties()
  return {
    terms: (
      <TermLink
        key='sign-up-terms-of-service'
        href={t('common:urls:termsOfServiceUrl')}
        color='Orca'
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'terms_of_service' })
        }}
      />
    ),
    consent: (
      <TermLink
        key='payment-options-consent'
        color='Orca'
        href={`${t('common:urls:termsOfServiceUrl')}#e-sign`}
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'payment_options_consent' })
        }}
      />
    ),
    communications: (
      <TermLink
        key='sign-up-electronic-communications'
        color='Orca'
        href={`${t('common:urls:termsOfServiceUrl')}#e-sign`}
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'electronic_communications' })
        }}
      />
    ),
    privacy: (
      <TermLink
        key='sign-up-privacy-policy'
        href={t('common:urls:privacyPolicyUrl')}
        color='Orca'
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'privacy_policy' })
        }}
      />
    ),
    optOut: (
      <TermLink
        key='sign-up-opt-out'
        href={t('common:urls:marketingOptOutUrl')}
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'marketing_opt_out' })
        }}
      />
    ),
    customerterms: (
      <TermLink
        key='sign-up-customer-terms'
        href={t('common:urls:customerTermsUrl')}
        color='Orca'
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'customer_terms' })
        }}
      />
    ),
    privacypolicy: (
      <TermLink
        key='sign-up-privacy-policy-pay-in-4'
        href={t('common:urls:privacyPolicyPayIn4Url')}
        color='Orca'
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'privacy_policy' })
        }}
      />
    ),
  }
}
